<template>
	<section class="invoices">
		
		<header class="invoices-header">
			<h2 class="invoices-title">Invoices</h2>
			<router-link
				class="btn btn-secondary"
				:to="{ path: '/console/payment/history' }"
				v-if="invoices && invoices.length > 0"
				>View All</router-link
			>
		</header>

		<InvoiceList
			v-if="!loading && invoices && invoices.length > 0"
			:invoices="invoices"
			@invoicepaid="getInvoices"
		/>
		
		<NoData
			:collectionName="'invoices'"
			v-if="
				!loading && !errMsg && (!invoices || invoices.length === 0)
			"
		/>
		
		<ErrorAlert v-if="!loading && errMsg" :error="errMsg" />

		<Spinner v-if="loading" />

	</section>
</template>

<script>
import InvoiceService from "../../services/invoice";
import InvoiceList from "./InvoiceList";
import Spinner from "../shared/Spinner";
import ErrorAlert from "../shared/ErrorAlert";
import NoData from "../shared/NoData";

export default {
	name: "InvoiceHomeCard",
	components: {
		InvoiceList,
		Spinner,
		ErrorAlert,
		NoData,
	},
	mounted() {
		this.getInvoices();
	},
	data() {
		return {
			invoices: [],
			loading: false,
			errMsg: null,
			user: null,
		};
	},
	methods: {
		getInvoices() {
			this.loading = true;
			InvoiceService.instance()
				.getInvoices({page:0, size: 3})
				.then((result) => {
					this.loading = false;
					this.errMsg = null;
					this.invoices = result.data.content;
				})
				.catch((err) => {
					this.loading = false;
					this.errMsg = err;
				});
		},
	},
};
</script>

<style scoped>
.light .card__container {
	border: 1px solid #d8d8d8;
}
.dark .card__container {
	border: 1px solid #4d4b4b;
}
.card__container {
	padding: 5px 25px 20px 25px;
	border: 1px solid #dadada;
	border-radius: 2px;
	box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2);
	margin-top: 20px;
}
.invoice__header {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.invoice__h {
	font-weight: bold;
	line-height: unset;
	margin-block-start: 0.83em;
	margin-block-end: 0.83em;
}
.invoice__grand-total {
	display: flex;
	align-items: center;
}
.light .invoice__grand-total,
.light .invoice__grand-txt {
	color: #212529;
}
.dark .invoice__grand-total,
.dark .invoice__grand-txt {
	color: #fafafa;
}
.invoice__grand-txt {
	margin-right: 15px;
}
.invoice__grand-num {
	font-size: 20px;
	font-weight: bold;
	margin-right: 15px;
}
.icon-right {
	display: block;
	width: 26px;
	height: 26px;
}
.spinner__body {
	position: relative;
	width: 100%;
	height: 250px;
}
.error__body {
	width: 100%;
	padding: 4rem 0;
}
</style>